module.exports = __webpack_public_path__ + "static/img/lmp_image@3x.05cea68.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/3x/lmp_image@3x.png
// module id = xKYY
// module chunks = 1